<template>
  <v-footer
    id="dashboard-core-footer"
  >
    <v-container>
      <v-row
        align="center"
        no-gutters
      >
        <v-col
          v-for="(link, i) in links"
          :key="i"
          class="text-center mb-sm-0 mb-5"
          cols="auto"
        >
          <a
            v-if="access.includes(link.access)"
            :href="link.href"
            class="mr-0 grey--text text--darken-3"
            rel="noopener"
            v-text="link.text"
          />
        </v-col>
        <v-spacer class="hidden-sm-and-down" />
        <v-col
          v-if="access.length>0"
          cols="12"
          md="auto"
        >
          <div class="text-body-1 font-weight-light pt-6 pt-md-0 text-center">
            Copyright &copy; 2026 - <a href="/">McDonald's Philippines</a>.
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
// rebuild
  import {
    mapState,
  } from 'vuex'
  export default {
    name: 'DashboardCoreFooter',
    computed: {
      ...mapState(['access', 'roles']),
      links () {
        return [
          {
            href: '/',
            text: 'Dashboard',
            access: this.roles.dashboard,
          },
          {
            href: '/my-account',
            text: 'My Account',
            access: this.roles.myaccount,
          },
          {
            href: '/settings',
            text: 'Settings',
            access: this.roles.settings,
          },
          {
            href: '/manager-forecast',
            text: 'Manager Forecast',
            access: this.roles.mforecast,
          },
          {
            href: '/crew',
            text: 'Crew List',
            access: this.roles.crewlist,
          },
          {
            href: '/scheduler',
            text: 'Scheduler',
            access: this.roles.scheduler,
          },
          {
            href: '/reports',
            text: 'Reports',
            access: this.roles.reports,
          },
          {
            href: '/biometrics',
            text: 'Biometrics',
            access: this.roles.biometrics,
          },
          {
            href: '/users',
            text: 'Users',
            access: this.roles.users,
          },
          {
            href: '/stores',
            text: 'Stores',
            access: this.roles.stores,
          },
        ]
      },
    },
  }
</script>

<style lang="sass">
  #dashboard-core-footer
    a
      font-size: .825rem
      font-weight: 500
      text-decoration: none
      text-transform: uppercase
</style>
